module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('div', {
      staticClass: "section-header with-border"
    }, [_vm._v("\n        " + _vm._s(item.name) + "   "), _c('small', [_vm._v(_vm._s(item.desc))])]), _vm._v(" "), _c('div', {
      staticClass: "content-padded"
    }, _vm._l((item.itemList), function(row, index) {
      return _c('el-row', {
        key: index,
        attrs: {
          "gutter": 20
        }
      }, [_c('el-col', [_c('div', {
        staticClass: "tip"
      }, [_c('div', {
        staticClass: "view-flex"
      }, [_c('div', {
        staticClass: "view-flex-item"
      }, [_c('p', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(row.desc))])]), _vm._v(" "), _c('el-button', {
        on: {
          "click": function($event) {
            return _vm.toForm(row.form)
          }
        }
      }, [_vm._v("选择")])], 1)])])], 1)
    }), 1)])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79f8e10a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f8e10a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/activity/templ.vue
// module id = 2848
// module chunks = 0